import React from 'react';

import CourseFilterWithSelection from './CourseFilterWithSelection';
import CourseFilterWithSlideUp from './CourseFilterWithSlideUp';

const CourseFilter = ({
  courseFilterVariant,
  expiredCoursesCount,
  selectedFilters,
  onFilterChange,
  dialogMessage,
  filterOptions,
  ...props
}) => {
  switch (courseFilterVariant) {
    case 'SlideUp': {
      return (
        <CourseFilterWithSlideUp
          expiredCoursesCount={expiredCoursesCount}
          selectedFilters={selectedFilters}
          onFilterChange={onFilterChange}
          dialogMessage={dialogMessage}
          filterOptions={filterOptions}
          {...props}
        />
      );
    }
    case 'Selection':
    default: {
      return (
        <CourseFilterWithSelection
          expiredCoursesCount={expiredCoursesCount}
          selectedFilters={selectedFilters}
          onFilterChange={onFilterChange}
          dialogMessage={dialogMessage}
          filterOptions={filterOptions}
          {...props}
        />
      );
    }
  }
};

export default CourseFilter;
